import React, { Component } from "react";
import europe from "../Europe";
import FeaturedItems from "../FeaturedItems";

export default class EuropeItems extends Component {
  render() {
    const Europe = europe.map(item => (
      <FeaturedItems key={item.id} item={item} />
    ));
    return (
      <React.Fragment>
        <div className="europe-parallax parallax d-flex justify-content-center align-items-center">
          <h1 className="main-photo-text">Europe</h1>
        </div>
        <div className="container">
          <div className="row mt-3 justify-content-md-center">{Europe}</div>
        </div>
      </React.Fragment>
    );
  }
}
